import { Navigate } from "@tanstack/react-router";
import { ExpensesScreen } from "@/components/expenses/ExpensesScreen";
import { useCurrentPerson } from "@/hooks/use-current-person";

/** Home when the server switch EXPENSES_ENABLED is off. */
export function ExpensesPage() {
  const me = useCurrentPerson().data;
  if (!me) return null;
  if (!me.expensesEnabled) return <Navigate to="/dashboard" replace />;
  return <ExpensesScreen />;
}
